import { cloneElement } from 'react'

import { useExpandableTextContext } from './ExpandableText'
import type { ExpandableTextTriggerProps } from './types'

export const Trigger = ({ children, ...props }: ExpandableTextTriggerProps) => {
  const { isExpanded, onToggle, textId } = useExpandableTextContext()

  if (!children) return null

  return cloneElement(children, {
    'aria-expanded': isExpanded,
    'aria-controls': textId,
    onClick: onToggle,
    ...props,
  })
}
